import {AbstractEvent} from "@/modules/base/events";
import {Player} from "@/modules/team/entity";

export class BeforePlayerCareerEndEvent extends AbstractEvent {
  constructor(
    public player: Player,
  ) {
    super();
  }
}